import {Link} from 'react-router-dom'
import { BsEye } from 'react-icons/bs'
import styles from './AccessButton.module.css'

function AccessButton({to}) {
    return (
        <Link className={styles.btn} to={to} onClick={(e) => e.stopPropagation()}>
            <BsEye /> Detalhes
        </Link>
    )
}

export default AccessButton